export default __webpack_public_path__ + "static/media/jldwhiteicon.b86f8e63.webp";